// Shared by the native and web variants of the homepage articles carousel.

/**
 * Newest articles on the homepage; the rest are a "See all" away on
 * /[lang]/articles, which the header links from every page. A few strong links
 * from the homepage say more about which articles matter than every article
 * at once, and keep the page's HTML from growing with the catalogue.
 */
export const HOME_ARTICLES_LIMIT = 6;
